import { useAuthSession } from '@modeling/account';
import { resolveCommitAuthorFromClaims } from '@modeling/git-file-viewer';
import { useCallback, useMemo } from 'react';
import type { CommitAuthor } from '@modeling/git-file-viewer';

export function useGitAuth() {
  const session = useAuthSession();

  const getToken = useCallback((): string => session.token ?? '', [session.token]);

  const commitAuthor = useMemo<CommitAuthor>(() => {
    const parsed = session.tokenParsed;
    return (
      resolveCommitAuthorFromClaims({
        preferred_username: parsed?.preferred_username,
        name: parsed?.name,
        email: parsed?.email,
        sub: parsed?.sub,
      }) ?? { name: 'unknown', email: 'unknown@users.noreply.local' }
    );
  }, [session.tokenParsed]);

  return { getToken, commitAuthor };
}
